import { render, staticRenderFns } from "./Loader.vue?vue&type=template&id=74d4bd66"
import script from "./Loader.vue?vue&type=script&lang=js"
export * from "./Loader.vue?vue&type=script&lang=js"
import style0 from "./Loader.vue?vue&type=style&index=0&id=74d4bd66&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ec2-user/workspace/Control-Panel/Control-Panel-Preprod/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('74d4bd66')) {
      api.createRecord('74d4bd66', component.options)
    } else {
      api.reload('74d4bd66', component.options)
    }
    module.hot.accept("./Loader.vue?vue&type=template&id=74d4bd66", function () {
      api.rerender('74d4bd66', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Utility/Loader.vue"
export default component.exports